import React from "react";
import ReactDOM from "react-dom/client";
import "./styles/gili-design/tokens.css";
import "./styles/gili-design/gili-design.css";
import "./global.css";
import App from "./App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
